/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseValidator} from "./BaseValidator";

export class RequiredValidator extends BaseValidator {
	constructor() {
		super();
	}

	name(model) {
		return "Is required"
	}

	logic(x) {
		return x != null && x !== '' && (typeof (x) != "string" || x.trim() != '');
	}

	message() {
		return "Required";
	}
}